import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectNewApp = (store: StoreSchema) => store.newApplicationState.newApplication